import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BookCall() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <section id="book-call" className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-34">
      {/* Background gradients */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-35">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#ff8a33]/10 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/4" data-id="element-36" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[120px] translate-y-1/2 -translate-x-1/4" data-id="element-37" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-38">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-39">
          {/* Left Column: Copy & Value Prop */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="pt-8 lg:sticky lg:top-24" data-id="element-40">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-[#ff8a33] text-sm font-medium mb-8 backdrop-blur-sm" data-id="element-41">
              <span className="relative flex h-2 w-2" data-id="element-42">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#ff8a33] opacity-75" data-id="element-43"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#ff8a33]" data-id="element-44"></span>
              </span>
              Limited Availability for New Partners
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-45">
              Ready to Turn Your Location Into a <br data-id="element-46" />
              <span className="text-gradient-orange" data-id="element-47">
                High-Performance Asset?
              </span>
            </h2>

            <p className="text-xl text-gray-400 mb-10 max-w-xl" data-id="element-48">
              Let's discuss your current challenges and map out a strategy that
              generates measurable growth. No pressure — just clarity and next
              steps.
            </p>

            <div className="space-y-6 mb-10" data-id="element-49">
              <div className="flex items-start gap-4" data-id="element-50">
                <div className="w-8 h-8 rounded-full bg-[#ff8a33]/20 flex items-center justify-center text-[#ff8a33] flex-shrink-0 mt-1" data-id="element-51">
                  <CheckCircle2 size={18} data-id="element-52" />
                </div>
                <div data-id="element-53">
                  <h4 className="text-white font-semibold text-lg mb-1" data-id="element-54">
                    Free 30-minute strategic consultation
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-55">
                    We'll analyze your current situation and identify immediate
                    opportunities.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-56">
                <div className="w-8 h-8 rounded-full bg-[#ff8a33]/20 flex items-center justify-center text-[#ff8a33] flex-shrink-0 mt-1" data-id="element-57">
                  <CheckCircle2 size={18} data-id="element-58" />
                </div>
                <div data-id="element-59">
                  <h4 className="text-white font-semibold text-lg mb-1" data-id="element-60">
                    Actionable insights
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-61">
                    Walk away with a clear roadmap for your specific
                    location(s).
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-62">
                <div className="w-8 h-8 rounded-full bg-[#ff8a33]/20 flex items-center justify-center text-[#ff8a33] flex-shrink-0 mt-1" data-id="element-63">
                  <CheckCircle2 size={18} data-id="element-64" />
                </div>
                <div data-id="element-65">
                  <h4 className="text-white font-semibold text-lg mb-1" data-id="element-66">
                    Zero hard sell
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-67">
                    If we're a good fit, great. If not, you still get value.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Calendly Widget */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-[#111] rounded-3xl border border-white/10 shadow-2xl overflow-hidden relative z-20" data-id="element-68">
            <div className="calendly-inline-widget w-full" data-url="https://calendly.com/christopherbrissette/new-meeting" style={{
            minWidth: '320px',
            height: '700px'
          }} data-id="element-69" />
          </motion.div>
        </div>
      </div>
    </section>;
}